import React from "react";
import LoaderGIF from "../images/JioLoader.svg";
import { Spinner } from "@jds/core";

export default (props) => (
    <>
        {props?.overlay && (
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                className="shc-overlay"
            ></div>
        )}
        {props.loadingCount > 0 && (
            <div
            // style={{
            //     position: "fixed",
            //     zIndex: "1000",
            //     top: "35%",
            //     left: "50%",
            //     transform: "translate(-50%, 0)",
            // }}
            // className="loader"
            >
                <div className="base-loader-overlay"></div>
                <Spinner
                    label="Loading..."
                    appearance="normal"
                    labelPosition="bottom"
                    className={`spinnerBaseLoader`}
                />

                {/* <img
                    style={{
                        width: "80px",
                        height: "80px",
                    }}
                    src={LoaderGIF}
                    alt=""
                /> */}
            </div>
        )}
    </>
);
